export const extractValidStepFromHTMLString = (
  htmlString: string,
): string[] => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // get the first main ul, assuming there's just one at the top level
  const rootUl = doc.body.querySelector('ul');
  if (!rootUl) return [];

  const steps: string[] = [];
  let currentStepText = '';
  let currentNestedUl: HTMLElement | null = null;

  // loop through everything directly inside the ul (not nested ones)
  for (const node of Array.from(rootUl.childNodes)) {
    if (node.nodeType !== Node.ELEMENT_NODE) continue;

    const el = node as HTMLElement;

    if (el.tagName === 'LI') {
      // if we already had a step in progress, push it first before starting a new one
      if (currentStepText) {
        const content = `<div>
        <p style="margin:0">${currentStepText}</p>
        ${
          currentNestedUl
            ? currentNestedUl.outerHTML.replace(
                'ul',
                'ul style="margin:0;padding-left:20px;"',
              )
            : ''
        }
      </div>`;
        steps.push(content);
        currentNestedUl = null;
      }

      // start the next step
      currentStepText = el.textContent?.trim() || '';
    } else if (el.tagName === 'UL') {
      // if a ul shows up here it's probably a child of the previous li, so attach it
      currentNestedUl = el.cloneNode(true) as HTMLElement;
    }
  }

  // finish the last step if it's still pending
  if (currentStepText) {
    const content = `<div>
    <p style="margin:0">${currentStepText}</p>
    ${
      currentNestedUl
        ? currentNestedUl.outerHTML.replace(
            'ul',
            'ul style="margin:0;padding-left:20px;"',
          )
        : ''
    }
  </div>`;
    steps.push(content);
  }

  return steps;
};
